
export const expertPaymentConstants = {
    LIST_EXPERT_PAYMENT_REQUEST: 'LIST_EXPERT_PAYMENT_REQUEST',
    LIST_EXPERT_PAYMENT_SUCCESS: 'LIST_EXPERT_PAYMENT_SUCCESS',
    LIST_EXPERT_PAYMENT_FAILURE: 'LIST_EXPERT_PAYMENT_FAILURE',

    CLEAR_EXPERT_BALANCE_REQUEST: 'CLEAR_EXPERT_BALANCE_REQUEST',
    CLEAR_EXPERT_BALANCE_SUCCESS: 'CLEAR_EXPERT_BALANCE_SUCCESS',
    CLEAR_EXPERT_BALANCE_FAILURE: 'CLEAR_EXPERT_BALANCE_FAILURE',
};

export const expertPaymentDescription = {
    CLEAR_BALANCE: (count) =>
        `You’re about to clear the balance for ${count} expert${count === 1 ? '' : 's'}. This action cannot be undone.`,
};